import React from "react";
import { IntercomProvider } from "react-use-intercom";
import { OrgRouter } from "./Org/OrgRouter";
import { OrgAndStaffRouterProps } from "./PrimaryNavUtils";

export const IntercomOrgProvider = ({ orgs, onOrgChange }: OrgAndStaffRouterProps) => {
  return (
    <IntercomProvider appId={process.env.REACT_APP_INTERCOM_APP_ID || ""}>
      <OrgRouter orgs={orgs} onOrgChange={onOrgChange} />
    </IntercomProvider>
  );
};
